import { render, staticRenderFns } from "./JifenDetails.vue?vue&type=template&id=6f72de60&scoped=true"
import script from "./JifenDetails.vue?vue&type=script&lang=js"
export * from "./JifenDetails.vue?vue&type=script&lang=js"
import style0 from "./JifenDetails.vue?vue&type=style&index=0&id=6f72de60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f72de60",
  null
  
)

export default component.exports